import styled from 'styled-components';

const ChartDetailWrapper = styled.div`
  height: calc(100% - 30px);
  .card {
    margin: 0 !important;
    margin-bottom: 25px !important;
    &.fixed-height {
      height: 95%;
      min-height: 300px;
    }
    .chartCard {
      min-height: 500px;
    }
    .chart-holder {
      height: ${(props) =>
        props?.isFilterApplied ? 'calc(100% - 70px)' : '100%'};
      &.table {
        overflow: auto;
        margin-top: 10px;
      }
    }
  }
`;

export { ChartDetailWrapper };
